import type { Thresholds } from './limits'

/** One line for a read-only row: `Repeats ≤ 10% · 1 unsourced claim · trust ≥ 70 · avoid list blocks`. */
export function summariseThresholds(stored: Thresholds): string {
  const claims = stored.max_unverifiable_claims
  return [
    `Repeats ≤ ${String(stored.max_similarity_pct)}%`,
    `${String(claims)} unsourced ${claims === 1 ? 'claim' : 'claims'}`,
    `trust ≥ ${String(stored.min_eeat_score)}`,
    stored.block_avoided_words ? 'avoid list blocks' : 'avoid list reports',
  ].join(' · ')
}
